import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { notificationsAPI } from '../../services/api';

const Notifications = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  const loadItems = async () => {
    const response = await notificationsAPI.getAll();
    setItems(response.notifications || []);
  };

  useEffect(() => {
    loadItems();
  }, []);

  const handleRead = async (id) => {
    await notificationsAPI.markRead(id);
    await loadItems();
  };

  return (
    <div className="student-dashboard">
      <div className="dashboard-header">
        <h1>{t('notification.title')}</h1>
      </div>
      <div className="courses-list">
        {items.map((item) => (
          <div key={item.id} className="course-card" style={{ display: 'block' }}>
            <h3>{item.title}</h3>
            <p>{item.message}</p>
            <small>{item.type}</small>
            {!item.isRead && (
              <div className="form-actions" style={{ marginTop: '8px' }}>
                <button className="btn-primary" onClick={() => handleRead(item.id)}>{t('notification.markRead')}</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;
